import { WarningToast } from "../CustomHooks/WarningToast";
import { deleteRequestHandler, getRequestHandler, postRequestHandler } from "../utils/utils";
import { BASE_URL, BASE_CORE_URL, UAPI_URL_CONFIG, UAPI_URL_CCTV, BASE_CORE_URL_MISC } from "./../config/index";
import { GetNewUsersList } from "./userManagementservice";

//Site  API'S

//#region Api Calling for Getting the Sitelist
export const Getsitelist = async () => {
  let userid = localStorage.getItem('UserID');
  let url = UAPI_URL_CONFIG + "site/getAllSites?UserId=" + userid;
  return getRequestHandler(url);
};
//#endregion

//#region Api Calling for Getting the Sitelist
export const getAllZones = async () => {
  let userid = localStorage.getItem('UserID');
  let url = UAPI_URL_CONFIG + "site/getAllZones?UserId=" + userid;
  return getRequestHandler(url);
};
//#endregion

//#region Api Calling for Getting the Sitelist
export const getZoneListAPI = async (parentId) => {
  let userid = localStorage.getItem('UserID');
  let url = UAPI_URL_CONFIG + "site/getAllSites?UserId=" + userid + "&ParentID=" + parentId;
  return getRequestHandler(url);
};
//#endregion

//#region Api Calling for Getting SiteTypeList
export const getSiteTypeList = async (obj) => {
  let url = UAPI_URL_CONFIG + "masters/getMasterData";
  return postRequestHandler(url, obj)
};
//#endregion

//#region Old Api Calling for Add Site
export const Addsitedetails = async (obj) => {
  let url = UAPI_URL_CONFIG + "site/addSite";
  return postRequestHandler(url, obj)
};
//#endregion

//#region Old Api Calling for Add Site Address
export const addSiteAddress = async (obj) => {
  let url = UAPI_URL_CONFIG + "site/addSiteAddress";
  return postRequestHandler(url, obj)
};
//#endregion

//#region Old Api Calling for Update Site
export const Updatesitedetails = async (obj) => {
  let url = UAPI_URL_CONFIG + "site/updateSite";
  return postRequestHandler(url, obj)
};
//#endregion

//#region Old Api Calling for Update Site Address
export const updateSiteAddress = async (obj) => {
  let url = UAPI_URL_CONFIG + "site/updateSiteAddress";
  return postRequestHandler(url, obj)
};
//#endregion

//#region Old Api Calling for Get Site Address By Id
export const getSiteByIdService = async (id) => {
  let userid = localStorage.getItem("UserID");
  let url = UAPI_URL_CONFIG + "site/getSiteDetailById?UserId=" + userid + "&Siteid=" + id;
  return getRequestHandler(url);
};
//#endregion

//#region Old Api Calling for Get Site Address By Id
export const getSiteAddressById = async (id) => {
  let userid = localStorage.getItem("UserID");
  let url = UAPI_URL_CONFIG + "site/getSiteAddressById?UserId=" + userid + "&Siteid=" + id;
  return getRequestHandler(url);
};
//#endregion

//#region  Api Calling for Adding the Customer Name
export const addCustomerName = async (obj) => {
  let url = UAPI_URL_CONFIG + "clients/addClient";
  return postRequestHandler(url, obj)
};
//#endregion

//#region Api Calling for Getting for Country
export const getCountryDetails = async (obj) => {
  let url = UAPI_URL_CONFIG + "masters/getMasterData";
  return postRequestHandler(url, obj)
};
//#endregion

//#region Api Calling for Getting the State
export const getStateDetails = async (countryMasterId) => {
  let obj = {
    type: "StateMaster",
    parameters: {
      countrymasterid: countryMasterId,
    },
  };
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json" ,
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = UAPI_URL_CONFIG + "masters/getMasterData";

  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("state details () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Getting the State
export const getCityDetails = async (statemasterid) => {
  let obj = {
    type: "CityMaster",
    parameters: {
      StateMasterID: statemasterid,
    },
  };
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json" ,
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = UAPI_URL_CONFIG + "masters/getMasterData";

  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("state details () Exception: ", error);
    });
};
//#endregion

//#region old Api Calling for Deleting the Customer
export const delete_customer = async (Userid, ClientId) => {
  let url = UAPI_URL_CONFIG + `customerConfig/deleteCustomer?Userid=${Userid}&ClientId=${ClientId}`;
  return getRequestHandler(url)
};
//#endregion

//#region old Api Calling for Deleting the Site
export const deletesite = async (userId, siteId) => {
  let url = UAPI_URL_CONFIG + `site/deleteSite?userId=${userId}&siteId=${siteId}`;
  return getRequestHandler(url)
};
//#endregion

//#region Api Calling for Getting Site List
export const getSiteList = async () => {
  let userId = JSON.parse(localStorage.getItem("user"));
  let userUniqueId = userId?.Id;
  let url = UAPI_URL_CONFIG + "site/getAllSites" + `?UserId=${userUniqueId}`;
  return getRequestHandler(url)
};
//#endregion

//#region Api Calling for Getting the SiteList basis on some parameter
export const SiteList = async (id, deviceTypeId, alertType, showAll) => {
  let userId = JSON.parse(localStorage.getItem("user"));
  let userUniqueId = userId?.Id;
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = BASE_CORE_URL_MISC + "AlertTemplate/SiteList?userId=" + userUniqueId + "&clientId=" + id + "&deviceTypeId=" + deviceTypeId + "&alertType=" + alertType + "&showAll=" + showAll;
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("SiteList () Exception", error);
    });
};
//#endregion

//MasterTableList

//#region Api Calling for Getting Master table List
export const Getmastertablelist = async (obj) => {
  const url = BASE_URL + "getmastertablelist";
  return postRequestHandler(url, obj)
};
//#endregion

//Event Template

//#region Api Calling for Adding Event Template
export const AddNewEventTemplate = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
       "Content-Type": "application/json",
       "authcode": localStorage.getItem("authCode"),
       "Authorization": "Bearer " + localStorage.getItem("authToken"),
      },
    body: JSON.stringify(obj),
  };
  return null;
  const url = BASE_URL + "addeventtemplate";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("AddNewEventTemplate() Exception: " + error);
    });
};
//#endregion

//#region Api Calling for Deleting Event Template
export const DeleteEventTemplate = async (eventTemplateID) => {
  if (eventTemplateID != null) {
    const requestOptions = {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        "authcode": localStorage.getItem("authCode"),
        "Authorization": "Bearer " + localStorage.getItem("authToken"),
      },
      body: JSON.stringify({
        alertTemplateID: eventTemplateID,
      }),
    };
return null;
    const url = BASE_URL + "deleteeventtemplate";
    return await fetch(url, requestOptions)
      .then((resp) => resp.json())
      .then(function (data) {
        return data;
      })
      .catch(function (error) {
        console.error(error);
      });
  } else {
    return undefined;
  }
};
//#endregion

//#region Api Calling for Getting the Event TemplateList
export const GetEventTemplateList = async () => {
  let userid = localStorage.getItem("UserID");
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      UserID: userid,
    }),
  };
return null;
  const url = BASE_URL + "geteventtemplatelist";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data.message;
    })
    .catch(function (error) {
      console.error(error);
    });
};
//#endregion

//Template (Alert)

//#region old Api Calling for Adding the Alert Template
export const addTemplate = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
return null;
  let url = BASE_URL + "addeventtemplate";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("addTemplate () Exception: ", error);
    });
};
//#endregion

//#region  old Api Calling for Updating the Alert Template
export const updateTemplate = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  return null;
  let url = BASE_URL + "updateeventtemplate";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("updateTemplate () Exception: ", error);
    });
};
//#endregion

//#region old Api Calling for Alert Template Crud
export const Alerttemplatecrud = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json" ,
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  return null;
  const url = BASE_URL + "alerttemplatecrud";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error(error);
    });
};
//#endregion

//#region old Api Calling for Getting Severity type
export const GetSeverityTypeList = async () => {
  let obj = {
    "type": "severity"
}
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = UAPI_URL_CONFIG + "masters/getMasterData";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error(error);
    });
};
//#endregion

//#region Api Callimg for Getting the Alert Template
export const GetAlertTemplate = async (
  pType,
  pageNumber,
  searchText,
  filterText
) => {
  let userId = JSON.parse(localStorage.getItem("user"));
  let userUniqueId = userId?.Id;
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url =
    BASE_CORE_URL_MISC + "AlertTemplate/GetAlertTemplate?pUserId=" + userUniqueId +"&pType=" + pType + "&pageNumber=" + pageNumber + "&searchText=" + searchText + "&filterText=" + filterText;
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("GetAlertTemplate () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Getting Schedule Log
export const GetAlertTemplateAudit = async (id, userId) => {
  // let userid = localStorage.getItem("UserID");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = BASE_CORE_URL_MISC + "AlertTemplate/GetScheduleLog?id=" + id + "&userId=" + userId;
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("GetAlertTemplateAudit () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for AlertTemplate DataToFilter
export const GetDataToFilter = async (pType, pSelectedIds,customerIds,siteIds,deviceTypeIds) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = BASE_CORE_URL_MISC + "AlertTemplate/GetDataToFilter?userId="+localStorage.getItem('UserID')+"&pType=" + pType + "&pSelectedIds=" + pSelectedIds + "&customerIds="+ customerIds + "&siteIds=" + siteIds + "&deviceTypeIds=" + deviceTypeIds;
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("GetDataToFilter () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Add Alert Template
export const AddAlertTemplateApI = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = BASE_CORE_URL_MISC + "AlertTemplate/AddAlertTemplate";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("AddAlertTemplateApI () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Update Alert Template
export const UpdateAlertTemplateApI = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = BASE_CORE_URL_MISC + "AlertTemplate/UpdateAlertTemplate";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("UpdateAlertTemplateApI () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Separate AlertTemplateByDevice
export const seperateAlertTemplateByDevice = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };

  let url = BASE_CORE_URL_MISC + "AlertTemplate/SeperateALertTemplateByDevice";
  //let url = BASE_CORE_URL + "AlertTemplate/SeperateALertTemplateByDevice";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("UpdateAlertTemplateApI () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for SplitAlertTemplateByDevice
export const splitAlertTemplateByDevice = async (
  alertTemplateId,
  deviceId,
  userId
) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  let url =
    BASE_CORE_URL +
    `AlertTemplate/SplitAlertTemplateByDevice?alertTemplateId=${alertTemplateId}&deviceId=${deviceId}&userId=${userId}`;

  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getDeviceTypeList () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Getting Alert Template by Id
export const getAlertTemplateByIdAPI = async (templateId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = BASE_CORE_URL_MISC + "AlertTemplate/GetAlertTemplateById?id=" + templateId;

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
    });
};
//#endregion

//#region Api Calling for Getting the AlertTemplate ByDeviceId
export const getAlertTemplateByDeviceIdAPI = async (deviceId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = BASE_CORE_URL_MISC + "AlertTemplate/GetAlertTemplateByDeviceId?deviceId=" + deviceId;

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
    });
};
//#endregion

//#region Api Calling for RemoveDevicefrom Temp
export const removeDeviceFromTemp = async (alertTemplateId, deviceId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  let url =
    BASE_CORE_URL +
    `AlertTemplate/RemoveDevice?alertTemplateId=${alertTemplateId}&deviceId=${deviceId}`;

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
    });
};
//#endregion

//#region Api Calling for Getting ZoneType Alert Template
export const getZoneTypeAlertTemp = async (deviceIds, showAll, alertCodeId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url =
    BASE_CORE_URL +
    `Site/GetZoneAlertTemp?deviceIds=${deviceIds}&showAll=${showAll}&alertCodeId=${alertCodeId}`;

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      console.log(data);
      return data;
    })
    .catch((err) => {
      console.log(err);
    });
};
//#endregion

//#region Api Calling for Delete the Alert Template
export const DeleteAlertTemplate2 = async (eventTemplateID) => {
  if (eventTemplateID != null) {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authcode: localStorage.getItem("authCode"),
        Authorization: "Bearer " + localStorage.getItem("authToken"),
      },
    };
    const url = BASE_CORE_URL_MISC + "AlertTemplate/DeleteAlertTemplate?id=" + eventTemplateID;
    return await fetch(url, requestOptions)
      .then((resp) => resp.json())
      .then(function (data) {
        return data;
      })
      .catch(function (error) {
        console.error(error);
      });
  } else {
    return undefined;
  }
};
//#endregion

//Device

//#region Api Calling for Deviceconfigcrud Details()
export const deviceconfigcrud = async (obj) => {
  let requestOptions = {};
  let url ='';
  if (obj.action =='addPanelZoneTypeMaster') {
    var newobj={
      type: "devicetype",
      params: {
        DeviceType: obj.zoneType,
        InterfaceTypeID: obj.interfaceTypeID
      }
    }
    requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newobj),
    };
    url = UAPI_URL_CONFIG + "masters/addMasterData";
  }
  else if (obj.action =='addPanelZones') {
    var newobj={
      type: "IDSZoneDevice",
      params: {
        UserID: obj.userUniqueId,
        ParentDeviceID: obj.parentDeviceId,
        ExternalId: obj.zoneNo,
        DeviceTypeID: obj.iDSPanelZoneTypeID,
        Name: obj.zoneName,
        DeviceId: 0,
        SerialNo:obj.SerialNo
      }
    }
    requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newobj),
    };
    url = UAPI_URL_CONFIG + "masters/addMasterData";
  }
  else if (obj.action =='updatePanelZone') {
    var newobj={
      type: "IDSZoneDevice",
      params: {
        UserID: obj.userUniqueId,
        //ParentDeviceID: obj.idsPanelZonesID,
        ExternalId: obj.zoneNo,
        DeviceTypeID: obj.idsPanelZoneTypeID,
        Name: obj.zoneName,
        DeviceId: obj.deviceId,
        SerialNo:obj.SerialNo
      }
    }
    requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newobj),
    };
    url = UAPI_URL_CONFIG + "masters/updateMasterData";
  }
  else if (obj.action =='getAssociatedCamerasList') {
    //getAssociationDevice?clientIds=30&siteIds=2&parentDeviceId=1&devicesId=10&deviceType=camera&userId=40FB9380-2BE6-4242-98ED-D8484935913F
    url = UAPI_URL_CCTV + "getAssociationDevice?siteIds="+obj.siteId+"&devicesId="+obj.deviceId+"&deviceType=camera&userId="+localStorage.getItem('UserID');
  }
  else if (obj.action=='associateCamerasToSensor'){
    var selecteddeviceDetails="";
    var selectedDevices=obj.associatedCameraIds;
    for (let index = 0; index < selectedDevices.length; index++) {
      selecteddeviceDetails = selecteddeviceDetails+ selectedDevices[index]+",";
      
    }
   // if (selecteddeviceDetails != "") {
      var newobj={
        userId: localStorage.getItem('UserID'),
        associatedCameraIds: selecteddeviceDetails,
        deviceId: obj.deviceId
      
      }
    requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newobj),
    };
    url = UAPI_URL_CCTV + "addAssociateCamera?deviceId="+obj.deviceId+"&associatedCameraIds="+selecteddeviceDetails+"&userId="+localStorage.getItem('UserID');
   // }
    // else{
    //   // WarningToast('Please select camera devices');
    //   return "Please select camera devices"
    // }
  }
  else{
    requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    };
    url = UAPI_URL_CONFIG + "masters/getMasterData";
  }
  
  
  // let url = BASE_URL + "deviceconfigcrud";
  
   
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("deviceconfigcrud () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Deviceconfigcrud Details()
export const addDevice = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = UAPI_URL_CONFIG + "deviceConfig/add_nvr_camera";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("deviceconfigcrud () Exception: ", error);
    });
};

export const addMultipleDevice = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = UAPI_URL_CONFIG + "deviceConfig/add_multiple_nvr_camera";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("deviceconfigcrud () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for update device()
export const updateDevice = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json" ,
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };

  let url = UAPI_URL_CONFIG + "deviceConfig/update_all_camera";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("deviceconfigcrud () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Bulk upload Camera
export const bulkUploadCamera = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };

  //let url = BASE_CORE_URL + "Device/DeviceBulkUpload";
  let url = UAPI_URL_CONFIG + "deviceConfig/deviceBulkUpload/"
  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
    });
};
//#endregion

//#region Api Calling for Bulk upload Panel
export const bulkUploadPanel = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };

  /* ---------------------- Endpoint needs to be changed for panel --------------------- */
  let url = UAPI_URL_CONFIG + "deviceConfig/panelBulkUpload/";
  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
    });
};
//#endregion

//#region Api Calling for Bulk upload ACS
export const bulkUploadACS = async (obj,interfaceType) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = ""
  /* ---------------------- Endpoint needs to be changed for panel --------------------- */
  if (interfaceType === "ACS"){
     url = UAPI_URL_CONFIG + "deviceConfig/acsBulkUpload";
  }else if(interfaceType === "RTU"){
    url = UAPI_URL_CONFIG + "deviceConfig/rtuBulkUpload";
  }else if(interfaceType === "Fire Panel"){
    url = UAPI_URL_CONFIG + "deviceConfig/firePanelBulkUpload";
  }
  
  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
    });
};
//#endregion

//#region  Api Calling for Getting DeviceTypeList
export const getDeviceTypeList = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj)
  };
  let url = UAPI_URL_CONFIG + "masters/getMasterData";

  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getDeviceTypeList () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Getting the Device Data
export const Getdeviceslistdata = async () => {
  let user = JSON.parse(localStorage.getItem("user"));
  let useruniqueid = user?.UserUniqueID;
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      UserUniqueID: useruniqueid,
    }),
  };
return null;
  const url = BASE_URL + "getstreamingurllist";
  return fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data.message;
    })
    .catch(function (error) {
      console.error({ error });
    });
};

export const GetDevicesListData = async (clientIds, siteIds, interfaceSubTypeIds, interfaceIds, deviceIds, deviceType) => {
  let user = JSON.parse(localStorage.getItem('user'));
  let uniqueId = user?.Id;
  
  // Use POST request with body instead of GET with URL params to avoid 414 errors
  const requestBody = {
    uniqueId: uniqueId,
    clientIds: clientIds ?? "",
    siteIds: siteIds ?? "",
    interfaceSubTypeIds: interfaceSubTypeIds ?? "",
    interfaceIds: interfaceIds ?? "",
    devicesIds: deviceIds ?? "",
    deviceType: deviceType ?? ""
  };
  
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(requestBody)
  };
  
  // Try POST first, fallback to GET if needed
  let url = UAPI_URL_CCTV + "getSelectAllDevice";
  
  try {
    let response = await fetch(url, requestOptions);
    
    // If POST fails with 405 (Method Not Allowed), fallback to GET
    if (response.status === 405) {
      console.warn("POST not supported, falling back to GET");
      const getOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authcode: localStorage.getItem("authCode"),
          Authorization: "Bearer " + localStorage.getItem("authToken"),
        },
      };
      const getUrl = UAPI_URL_CCTV + "getSelectAllDevice" + `?uniqueId=${uniqueId}&clientIds=${clientIds ?? ""}&siteIds=${siteIds ?? ""}&interfaceSubTypeIds=${interfaceSubTypeIds ?? ""}&interfaceIds=${interfaceIds ?? ""}&devicesIds=${deviceIds ?? ""}&deviceType=${deviceType ?? ""}`;
      response = await fetch(getUrl, getOptions);
    }
    
    let res = await response.json();
    
    if (res?.Status === "success" && res?.Data) {
      let temp = res?.Data.map((item) => {
        const { Communicationport, DeviceTypeID, SiteId, SiteName, TimeZoneID, Name, IsPtz, 
          RTSPCameraUrl, cctvHooterEnabledFlag, isTwoWayEnabled, CamPassword, CameraPort, 
          CamUser, ChannelNo, CameraIp, IsTranscodingEnabled, IsPlayBackTranscodingEnabled, 
          InternetProtocolPort, CameraGuid, DeviceId, ClientName, CameraBrandId, Abbreviation,
          BrandName, EntityType, SiteID, OffsetMinutes } = item
        return {
            CCTVType: EntityType,
            Abbreviation: Abbreviation,
            BranchID: SiteID,
            BrandName: BrandName,
            CameraBrandId: CameraBrandId,
            CameraName: Name,
            CommunicationPort: Communicationport,
            DeviceTypeID: DeviceTypeID,
            IsPTZ: IsPtz,
            Location: Location,
            OffsetMinutes: OffsetMinutes,
            ParentCameraID: DeviceId,
            RTSPURL: RTSPCameraUrl,
            ShowHooter: cctvHooterEnabledFlag,
            ShowTwoWay: isTwoWayEnabled,
            SiteID: SiteId,
            SiteName: SiteName,
            StreamName: CameraGuid,
            StreamingURL: "",
            TimeZoneId: TimeZoneID,
            camPassword: CamPassword,
            camPort: CameraPort,
            camUserName: CamUser,
            channelNum: ChannelNo,
            httpPort: InternetProtocolPort,
            isChecked: false,
            isPlaybackTranscoded: IsPlayBackTranscodingEnabled ? "1" : "0",
            isTranscoded: IsTranscodingEnabled ? "1" : "0",
            playbackURL: null,
            privateIPAddress: CameraIp,
            ClientName: ClientName
        } 
      })
      return temp;
    }
  } catch (error) {
    console.error("GetDevicesListData error:", error);
  }
};

export const GetDevicesListDataForPanel = async (clientIds, siteIds, interfaceSubTypeIds, interfaceIds, deviceIds, deviceType) => {
  let user = JSON.parse(localStorage.getItem('user'));
  let uniqueId = user?.Id;
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  const url = UAPI_URL_CCTV + "getSelectAllDeviceforPanel" + `?uniqueId=${uniqueId}&clientIds=${clientIds}&siteIds=${siteIds}&interfaceSubTypeIds=${interfaceSubTypeIds}&interfaceIds=${interfaceIds}&devicesIds=${deviceIds}&deviceType=${deviceType}`;
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (res) {
      if (res?.Status === "success" && res?.Data) {
        let temp = res?.Data.map((item) => {
          const { Communicationport, DeviceTypeID, SiteId, SiteName, TimeZoneID, Name, IsPtz, 
            RTSPCameraUrl, cctvHooterEnabledFlag, isTwoWayEnabled, CamPassword, CameraPort, 
            CamUser, ChannelNo, CameraIp, IsTranscodingEnabled, IsPlayBackTranscodingEnabled, 
            InternetProtocolPort, CameraGuid, DeviceId, ClientName, CameraBrandId, Abbreviation,
            BrandName, EntityType, SiteID, OffsetMinutes } = item
        return {
            CCTVType: EntityType,
            Abbreviation: Abbreviation,
            BranchID: SiteID,
            BrandName: BrandName,
            CameraBrandId: CameraBrandId,
            CameraName: Name,
            CommunicationPort: Communicationport,
            DeviceTypeID: DeviceTypeID,
            IsPTZ: IsPtz,
            Location: Location,
            OffsetMinutes: OffsetMinutes,
            ParentCameraID: DeviceId,
            RTSPURL: RTSPCameraUrl,
            ShowHooter: cctvHooterEnabledFlag,
            ShowTwoWay: isTwoWayEnabled,
            SiteID: SiteId,
            SiteName: SiteName,
            StreamName: CameraGuid,
            StreamingURL: "",
            TimeZoneId: TimeZoneID,
            camPassword: CamPassword,
            camPort: CameraPort,
            camUserName: CamUser,
            channelNum: ChannelNo,
            httpPort: InternetProtocolPort,
            isChecked: false,
            isPlaybackTranscoded: IsPlayBackTranscodingEnabled ? "1" : "0",
            isTranscoded: IsTranscodingEnabled ? "1" : "0",
            playbackURL: null,
            privateIPAddress: CameraIp,
            ClientName: ClientName
        } 
        })
        return temp;
      }
    })
    .catch(function (error) {
      console.error({ error });
    });
};
//#endregion

//#region Api Calling for Adding the Device
export const SaveDeviceDetails = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
     },
    body: JSON.stringify(obj),
  };
return null;
  let url = BASE_URL + "addcameraconfigdetails";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("SaveDeviceDetails() Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Update the Device
export const UpdateDeviceDetails = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
return null;
  let url = BASE_URL + "updatecameraconfigdet";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("UpdateDeviceDetails() Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Getting Device List
export const GetDeviceList = async (
  siteIds,
  deviceTypeId,
  IDSPanelZoneTypeID,
  alertType,
  showAll
) => {
  let user = JSON.parse(localStorage.getItem('user'));
  let userUniqueId = user?.Id
  console.log("checkId",userUniqueId)
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  // let url = BASE_CORE_URL + `Device/GetDeviceList?siteIds=${siteIds}&deviceTypeId=${deviceTypeId}&IDSPanelZoneTypeID=${IDSPanelZoneTypeID}&alertType=${alertType}&showAll=${showAll}`;
  let url = BASE_CORE_URL_MISC + `AlertTemplate/GetDeviceList?userId=${userUniqueId}&siteIds=${siteIds}&deviceTypeId=${deviceTypeId}&IDSPanelZoneTypeID=${IDSPanelZoneTypeID}&alertType=${alertType}&showAll=${showAll}`;
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("GetDeviceList () Exception", error);
    });
};
//#endregion

//#region Api Calling for PanelZoneType
export const getPanelZoneType = async () => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = BASE_CORE_URL + "Device/GetPanelZoneType";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getPanelZoneType () Exception: ", error);
    });
};
//#endregion

// Interfaces

//#region Api Calling for Getting InterfaceType
export const getInterfaceTypeData = async (obj) => {
  const requestOptions = {
   
      method: "POST",
      headers:{ 
        "Content-Type": "application/json",
        "authcode": localStorage.getItem("authCode"),
        "Authorization": "Bearer " + localStorage.getItem("authToken"),
      },
      body: JSON.stringify(obj),
    
  };
  let url = UAPI_URL_CONFIG + "masters/getMasterData";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getInterfaceTypeData () Exception: ", error);
    });
}
//#endregion

//#region Api Calling for Getting InterfaceSubType
export const getInterfaceSubTypeData = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem("authCode"),
      "Authorization": "Bearer " + localStorage.getItem("authToken"),
     },
    body: JSON.stringify(obj),
  };
  let url = UAPI_URL_CONFIG + "masters/getMasterData";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getInterfaceSubTypeData () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Getting InterfaceList
export const getInterfaceList = async (userId, siteid) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  let url =
    UAPI_URL_CONFIG +
    `interface/getInterface?userId=${userId}&siteId=${siteid}`;
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getInterfaceList () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Adding the Interface
export const addInterfaceDetails = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = UAPI_URL_CONFIG + "interface/addInterface";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("addInterfaceDetails () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Update the Interaface
export const updateInterfaceDetails = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = UAPI_URL_CONFIG + "interface/updateInterface";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("updateInterfaceDetails () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Delete the Interface
export const deleteInterfaceDetails = async (userId, interfaceId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    // body: JSON.stringify(obj),
  };

  // let url = BASE_CORE_URL + "Interface/Delete";
  let url = UAPI_URL_CONFIG + `interface/deleteInterface?userId=${userId}&interfaceId=${interfaceId}`;

  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("deleteInterfaceDetails () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Delete the Interface
export const deleteDeviceService = async (userId, deviceId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    // body: JSON.stringify(obj),
  };

  // let url = BASE_CORE_URL + "Interface/Delete";
  let url = UAPI_URL_CONFIG + `deviceConfig/deleteDevice?userId=${userId}&deviceId=${deviceId}`;

  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      console.log(data);
      return data;
    })
    .catch(function (error) {
      console.error("deleteInterfaceDetails () Exception: ", error);
    });
};
//#endregion


//entity subtype

//#region Api Calling for Getting Entity Subtype
export const getCCTVType = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(obj),
  };
  let url = UAPI_URL_CONFIG + "masters/getMasterData";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("CCTVType () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Customer List
export const getCustomerList = async (deviceTypeId, alertType, showAll) => {
  let userId = JSON.parse(localStorage.getItem("user"));
  let userUniqueId = userId?.Id;
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = BASE_CORE_URL_MISC + `AlertTemplate/CustomerList?userId=${userUniqueId}&deviceTypeId=${deviceTypeId}&alertType=${alertType}&showAll=${showAll}`;

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
    });
};
//#endregion



//Alert Prepost

//#region Api Calling for Add AlertPrepost
export const addAlertPrePostDetails = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = UAPI_URL_CONFIG + "alertPrePost/addAlertPrePostConfig/";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("addAlertPrePostDetails () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Update AlertPrePost
export const updateAlertPrePostDetails = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };

  let url = UAPI_URL_CONFIG + "alertPrePost/updateAlertPrePostConfig/";

  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("updateAlertPrePostDetails () Exception: ", error);
    });
};
//#endregion

//#region Api Calling for Getting AlertPrepostList

export const getAlertPrePostList = async (ClientId) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let uniqueId = loggedInUser?.Id
  let UserId = localStorage.getItem('UserID');
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  let url =
    UAPI_URL_CONFIG + `alertPrePost/getAlertPrePostConfigById/?UserId=`+localStorage.getItem('UserID') + `&ClientId=` + ClientId 
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getAlertPrePostList () Exception: ", error);
    });
};
//#endregion

//#region Api calling for Getting Alert Type
export const getAlertTypelist = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj)
  };
  let url = UAPI_URL_CONFIG + "masters/getMasterData"
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("GetAlertTypeList () Exception: ", error);
    });
};

//#region Api calling for Getting AllSeverity
export const GetSeverity = async () => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  // let UserId = localStorage.getItem('UserID');
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = UAPI_URL_CONFIG + `severitySound/getAllSeveritySound?UserId=`+localStorage.getItem('UserID')
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("GetAllSeverity () Exception: ", error);
    });
};
//#endregion

//#region Api calling for Update the SoundSetting Function
// export const UpdateSoundSettingFunction = async (extreme, high, moderate, low) => {
//   const requestOptions = {
//     method: "GET",
//     "Content-Type": "application/json",
//     "authcode": localStorage.getItem('authCode'),
//     "Authorization": "Bearer " + localStorage.getItem('authToken')
//   }

//   let url = BASE_CORE_URL + `SoundSetting/Update?extreme=${extreme}&high=${high}&moderate=${moderate}&low=${low}`;

//   return await fetch(url, requestOptions)
//     .then(res => res.json())
//     .then(data => {
//       return data;
//     })
//     .catch(function (error) {
//       console.error("Update () Exception: ", error);
//     });
// }
//#endregion

//#region Api calling for Update the SoundSetting
export const UpdateSoundSettingFunction = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = UAPI_URL_CONFIG + "severitySound/updateSeveritySound";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("UpdateSoundSetting () Exception: ", error);
    });
};
//#endregion

//#region Api calling for Panel Setting List
export const getAllPanelList = async (pageNumber, searchText, filterText) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  let url =
    BASE_CORE_URL +
    "Device/GetAllPanelList?pageNumber=" +
    pageNumber +
    "&searchText=" +
    searchText +
    "&filterText=" +
    filterText;

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
    });
};
//#endregion

//#region Api calling for Panel Setting detailsbyId
export const getPanelSettingDetailsById = async (deviceId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  let url = BASE_CORE_URL + "Device/GetPanelListById?deviceId=" + deviceId;
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getPanelSettingDetails () Exception: ", error);
    });
};
//#endregion

export const GetPanelFilterData = async (pType, pSelectedIds) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url =
    BASE_CORE_URL +
    "Device/GetPanelDataToFilter?pType=" +
    pType +
    "&pSelectedIds=" +
    pSelectedIds;
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("GetPanelFilterData () Exception: ", error);
    });
};

export const GetAllClientsUAPI = async (userId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  let url = UAPI_URL_CONFIG + "clients/getAllClients/?userId=" + userId;
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("GetAllClientsUAPI() Exception: ", error);
    });
};

// export const GetStateUAPI = async (obj) => {

//   const requestOptions = {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(obj),
//   };

//   let url = UAPI_URL_CONFIG + "masters/getMasterData";
//   return await fetch(url, requestOptions)
//     .then((resp) => resp.json())
//     .then(function (data) {
//       return data;
//     })
//     .catch(function (error) {
//       console.error("GetStateUAPI () Exception: ", error);
//     });
// }

export const getDeviceData = async (interfaceId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  let url =
    UAPI_URL_CONFIG + "deviceConfig/get_all_device?interfaceId=" + interfaceId+"&userId="+localStorage.getItem('UserID');
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("GetAllClientsUAPI() Exception: ", error);
    });
};

export const getDeviceBySiteIdAPI = async (siteId, zoneId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  let url = UAPI_URL_CONFIG + "deviceConfig/getDeviceBySiteId?siteId=" + siteId+ "&zoneId=" + zoneId + "&userId="+localStorage.getItem('UserID');
  //http://127.0.0.1:8001/api/config/deviceConfig/getDeviceBySiteId?siteId=61&zoneId=62

  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("GetAllClientsUAPI() Exception: ", error);
    });
};

export const addSiteZoneMapAPI = async (obj) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj)
  }

  let url = UAPI_URL_CONFIG + "site/addSiteZoneMap"

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data
    })
    .catch(err => console.log(err))
}

export const getEmergencyContactsBysite = async(SiteID) =>{
  const requestOptions = {
    method : "GET",
    headers:{
      "Content-Type" : "application/json",
      authcode : localStorage.getItem("authCode"),
      Authorization : "Bearer" + localStorage.getItem("authToken"),
    },
  };

  let url =
    UAPI_URL_CONFIG + `emergencyContact/getAllEmergencyContactById/?UserId=` + localStorage.getItem('UserID') + `&SiteID=` + SiteID;
    return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data)
  {
    return data;
  })
  .catch(function (error){
    console.error("GetEmergencyContactBySite() Exception:", error);
  });

};

export const addEmergencyContactBySite = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = UAPI_URL_CONFIG + "emergencyContact/addEmergencyContact/";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("AddEmergencyContactBySite () Exception: ", error);
    });
};

export const updateEmergencyContactBySite = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
  let url = UAPI_URL_CONFIG + "emergencyContact/updateEmergencyContact/";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("UpdateEmergencyContactBySite () Exception: ", error);
    });
};

export const deleteEmergencyContactsBysite = async(EmergencyContactID) =>{
  const requestOptions = {
    method : "DELETE",
    headers:{
      "Content-Type" : "application/json",
      authcode : localStorage.getItem("authCode"),
      Authorization : "Bearer" + localStorage.getItem("authToken"),
    },
  };

  let url =
    UAPI_URL_CONFIG + `emergencyContact/deleteEmergencyContact/?EmergencyContactID=` + EmergencyContactID
    return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data)
  {
    return data;
  })
  .catch(function (error){
    console.error("DeleteEmergencyContactBySite() Exception:", error);
  });

};

export const getCategoryIdlist = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj)
  };
  let url = UAPI_URL_CONFIG + "masters/getMasterData"
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getCategoryIdlist () Exception: ", error);
    });
};

//#region Api Calling for Getting Device Type Id
export const getDeviceTypeOnInterfaceId = async (id) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  let url = UAPI_URL_CONFIG + "interface/deviceTypeOnInterfaceId?interfaceTypeId=" + id;
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("GetAlertTemplateAudit () Exception: ", error);
    });
};
//#endregion

export const getDeviceStagedata = async () => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify({ "type": "DeviceStage"})
  };

  let url = UAPI_URL_CONFIG + "masters/getMasterData";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getDeviceStagedata () Exception: ", error);
    });
};

export const addCentralizeRecordingSystem = async (obj) => {
  let url = UAPI_URL_CONFIG + "centralizeRecording/addCentralizeRecording";
  return postRequestHandler(url, obj)
   
};

export const updateCentralizeRecordingSystem = async (obj) => {
  let url = UAPI_URL_CONFIG + "centralizeRecording/updateCentralizeRecording";
  return postRequestHandler(url, obj)
   
};

export const GetCentralizeRecordingSystem = async () => {
   //let OrganizationMasterID = localStorage.getItem('OrganizationMasterID');
   let loggedInUser = JSON.parse(localStorage.getItem('user'))
   let OrganizationMasterID = loggedInUser?.OrganizationMasterID
  let url = UAPI_URL_CONFIG + "centralizeRecording/getCentralizeRecording?OrganizationMasterID=" + OrganizationMasterID;
  return getRequestHandler(url);
};

export const deleteCentralizeRecordingSystem = async (RecordingStorageID) => {
  let url = UAPI_URL_CONFIG + "centralizeRecording/deleteCentralizeRecording?RecordingStorageID=" + RecordingStorageID;
  return getRequestHandler(url)
};

export const getStorageType = async () => {
 let url = UAPI_URL_CONFIG + "centralizeRecording/getStorageType";
 return getRequestHandler(url);
};

export const getInterfaceTypeBySite = async (siteIds) => {
  let url = UAPI_URL_CONFIG + "interface/getInterfaceSubTypeBySiteId" + `?siteId=${siteIds}`;
  return getRequestHandler(url);
 };

export const getInterfaceById = async (id) => {
  let user = JSON.parse(localStorage.getItem('user'))
  let url = UAPI_URL_CONFIG + "interface/getInterfaceById" + `?userId=${user?.Id}&interfaceId=${id}`;
  return getRequestHandler(url);
}

 export const getInterfaceName = async (interfaceSubTypeIds, siteIds) => {
  let user = JSON.parse(localStorage.getItem('user'))
  let url = UAPI_URL_CONFIG + "interface/getInterface" + `?userId=${user?.Id}&interfaceSubtypeId=${interfaceSubTypeIds}&siteId=${siteIds}`;
  return getRequestHandler(url);
 };

 export const getFilterRecording = async (clientIds, siteIds, interfaceSubTypeIds, interfaceIds) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let uniqueId = loggedInUser?.Id        
  let url = UAPI_URL_CCTV + "getSelectAllDevice" + `?uniqueId=${uniqueId}&clientIds=${clientIds}&siteIds=${siteIds}&interfaceSubTypeIds=${interfaceSubTypeIds}&interfaceIds=${interfaceIds}&deviceType=Camera`;
  return getRequestHandler(url);
 };

 export const getStorageList = async (RecordingStorageID) => {
  let url = UAPI_URL_CONFIG + "centralizeRecording/getStorage?RecordingStorageID=" + RecordingStorageID;
  return getRequestHandler(url);
 };

 export const addStorageForm = async (obj) => {
  let url = UAPI_URL_CONFIG + "centralizeRecording/addStorage";
  return postRequestHandler(url, obj)
   
};

export const updateStorageForm = async (obj) => {
  let url = UAPI_URL_CONFIG + "centralizeRecording/updateStorage";
  return postRequestHandler(url, obj)
   
};

export const deleteStorageDetails = async (RecordingStoragePathID) => {
  let url = UAPI_URL_CONFIG + "centralizeRecording/deleteStorage?RecordingStoragePathID=" + RecordingStoragePathID;
  return getRequestHandler(url)
};

export const addStorageTableForm = async (obj) => {
  let url = UAPI_URL_CONFIG + "centralizeRecording/addStorageFormTable";
  return postRequestHandler(url, obj)
   
};
export const updateStorageTableForm = async (obj) => {
  let url = UAPI_URL_CONFIG + "centralizeRecording/updateStorageFormTable";
  return postRequestHandler(url, obj)
   
};

export const deleteStorageTableFormDetails = async (DeviceRecordingConfigID) => {
  let url = UAPI_URL_CONFIG + "centralizeRecording/deleteStorageFormTable?DeviceRecordingConfigID=" + DeviceRecordingConfigID;
  return getRequestHandler(url)
};

export const getStorageTableFormDetails = async (obj) => {
   let url = UAPI_URL_CCTV + "getAllStorageDevice";
   return postRequestHandler(url,obj)
};

export const GetLicenseInformation = async () => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  let OrganizationMasterID = loggedInUser?.OrganizationMasterID
  let url = UAPI_URL_CONFIG + "license/getLicenseInfo?UserID=" + UserID + "&OrganizationMasterID=" + OrganizationMasterID;
  return getRequestHandler(url);
};

export const panelUpdateServices = async (obj) => {
  let url = UAPI_URL_CONFIG + "license/updatePanelServices";
  return postRequestHandler(url,obj);
};

export const getReportsDataset = async (obj) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  const url = `${UAPI_URL_CONFIG}reports/getReportsDataset?UserId=${UserID}`;
  return getRequestHandler(url,obj);
}

export const getReportsDatasetByReportID = async (obj) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  const url = `${UAPI_URL_CONFIG}reports/getReportsDataset?UserId=${UserID}&ReportID=${obj.ReportID}`;
  return getRequestHandler(url,obj);
}

export const getReportsDatasetColumns = async (selectedDatasetId) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  const url = `${UAPI_URL_CONFIG}reports/getDatasetColumns?UserId=${UserID}&ReportDataSetID=${selectedDatasetId}`;
  return getRequestHandler(url);
}

export const getReportsDatasetColumnsById = async (selectedDatasetId, ReportID,FromDateTime=null,ToDateTime=null) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  let url = `${UAPI_URL_CONFIG}reports/getDatasetColumns?UserId=${UserID}&ReportDataSetID=${selectedDatasetId}&ReportID=${ReportID}`;
  if(FromDateTime && ToDateTime){
    url += `&FromDateTime=${FromDateTime}&ToDateTime=${ToDateTime}`;
  }
  return getRequestHandler(url);
}

export const addReport = async (obj) => {
  let url = UAPI_URL_CONFIG + "reports/addReport";
  return postRequestHandler(url,obj);
}

export const updateReport = async (obj) => {
  let url = UAPI_URL_CONFIG + "reports/updateReport";
  return postRequestHandler(url,obj);
}

export const getReportList = async (obj) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  const url = `${UAPI_URL_CONFIG}reports/getAllReports?UserID=${UserID}`;
  return getRequestHandler(url, obj);
}

export const getUsers = async () => {
  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  try {
    const obj = {
      UserId: loggedInUser?.Id,
    };

    const resp = await GetNewUsersList(obj.UserId); // Await the promise
    if (resp.status === "Ok") {
      return resp.message; // Return the result
    } else if (resp.Status === "success") {
      return resp.Data; // Return the result
    } else {
      console.error("Unexpected response:", resp);
      return null; // Handle unexpected responses
    }
  } catch (error) {
    console.error("Error in getUsers:", error);
    throw error; // Re-throw the error for further handling
  }
};

export const getAssignedUserList = async (obj = {}) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'));
  let UserID = loggedInUser?.Id;
  let url = `${UAPI_URL_CONFIG}reports/getReportUserList?UserID=${UserID}`;
  if (obj.ReportID) {
    url += `&ReportID=${obj.ReportID}`;
  }
  return getRequestHandler(url, obj);
}

export const createDownloadRequest = async (obj) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  const url = `${UAPI_URL_CONFIG}reports/addDownloadRequest`;
  return postRequestHandler(url,obj);
}

export const validateBulkImport = async (obj) => {
  let url = UAPI_URL_CONFIG + "deviceConfig/validateBulkImport";
  return postRequestHandler(url,obj);
};

export const uploadBulkImport = async (obj) => {
  let url = UAPI_URL_CONFIG + "deviceConfig/uploadBulkImport";
  return postRequestHandler(url,obj);
};

export const deleteZoneDetails = async (userId, siteId) => {
  let url = UAPI_URL_CONFIG + `site/deleteZone?userId=${userId}&siteId=${siteId}`;
  return getRequestHandler(url)
};

export const getRecordingTypeList = async (ServerType) => {
  let url = UAPI_URL_CONFIG + `centralizeRecording/getRecordingBackupType?ServerType=${ServerType}`;
  return getRequestHandler(url);
};

export const AddCustomerDetails = async (obj) => {
  let url = UAPI_URL_CONFIG + "customerConfig/addCustomer";
  return postRequestHandler(url, obj)
};

export const UpdateCustomerDetails = async (obj) => {
  let url = UAPI_URL_CONFIG + "customerConfig/updateCustomer";
  return postRequestHandler(url, obj)
};

export const getAllFilters = async (obj) => {
  const { Entity = '' } = obj;
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  const url = `${UAPI_URL_CONFIG}filter/getFilterData?UserId=${UserID}&Entity=${Entity}`;
  return getRequestHandler(url, obj);
}

export const getAllCustomers = async (obj = {}) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  
  // Build URL with required UserID parameter
  let url = `${UAPI_URL_CONFIG}customerConfig/getCustomerList?UserID=${UserID}`;
  
  // Add optional StateID parameter
  if (obj.StateID) {
    url += `&StateID=${obj.StateID}`;
  }
  
  // Add optional City parameter
  if (obj.City) {
    url += `&City=${obj.City}`;
  }
  
  return getRequestHandler(url, obj);
}

export const getAllSiteList = async (obj = {}) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  
  // Build URL with required UserID parameter
  let url = `${UAPI_URL_CONFIG}site/getSiteList?UserId=${UserID}`;
  
  // Add optional ClientId parameter
  if (obj.CustomerID) {
    url += `&ClientId=${obj.CustomerID}`;
  }
  
  // Add optional StateID parameter
  if (obj.StateID) {
    url += `&StateID=${obj.StateID}`;
  }
  
  // Add optional City parameter
  if (obj.City) {
    url += `&City=${obj.City}`;
  }
  
  return getRequestHandler(url, obj);
}

export const getAllZoneList = async (obj = {}) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  
  // Build URL with required UserID parameter
  let url = `${UAPI_URL_CONFIG}zone/getZoneList?UserId=${UserID}`;
  
  // Add required SiteId parameter
  if (obj.SiteID) {
    url += `&SiteId=${obj.SiteID}`;
  }
  
  // Add required ClientId parameter
  if (obj.CustomerID || obj.ClientID) {
    url += `&ClientId=${obj.CustomerID || obj.ClientID}`;
  }

  if (obj.StateID) {
    url += `&StateID=${obj.StateID}`;
  }
  
  // Add optional City parameter
  if (obj.City) {
    url += `&City=${obj.City}`;
  }
  
  return getRequestHandler(url, obj);
}

export const getAllEmergencyContactList = async (obj = {}) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id

  console.log({obj})
  
  // Build URL with required UserID parameter
  let url = `${UAPI_URL_CONFIG}emergencyContact/getAllEmergencyContactList/?UserId=${UserID}`;
  
  // Add required ClientId parameter
  if (obj.CustomerID || obj.ClientID) {
    url += `&ClientId=${obj.CustomerID || obj.ClientID}`;
  }
  
  // Add required SiteId parameter
  if (obj.SiteID) {
    url += `&SiteId=${obj.SiteID}`;
  }

  //Add required Flag parameter
  if (obj.Flag) {
    url += `&Flag=${obj.Flag}`;
  }
  
  // Add optional ZoneId parameter
  if (obj.ZoneID) {
    url += `&ZoneId=${obj.ZoneID}`;
  }

  if (obj.StateID) {
    url += `&StateId=${obj.StateID}`;
  }
  
  // Add optional City parameter
  if (obj.CityID) {
    url += `&City=${obj.CityID}`;
  }
  
  return getRequestHandler(url, obj);
}

export const getAllInterfaceList = async (obj = {}) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  
  // Build URL with required UserID parameter
  let url = `${UAPI_URL_CONFIG}interface/getAllInterfaceList/?UserId=${UserID}`;
  
  // Add required ClientId parameter
  if (obj.CustomerID || obj.ClientID) {
    url += `&ClientId=${obj.CustomerID || obj.ClientID}`;
  }
  
  // Add required SiteId parameter
  if (obj.SiteID) {
    url += `&SiteId=${obj.SiteID}`;
  }

  if (obj.statemasterid) {
    url += `&StateID=${obj.statemasterid}`;
  }
  
  // Add optional City parameter
  if (obj.City) {
    url += `&City=${obj.City}`;
  }
  
  return getRequestHandler(url, obj);
}

export const getAllDeviceList = async (obj = {}) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  
  // Build URL with required UserID parameter
  let url = `${UAPI_URL_CONFIG}deviceConfig/getAllDeviceList/?UserId=${UserID}`;
  
  // Add required ClientId parameter
  if (obj.CustomerID || obj.ClientID) {
    url += `&ClientId=${obj.CustomerID || obj.ClientID}`;
  }
  
  // Add required SiteId parameter
  if (obj.SiteID) {
    url += `&SiteId=${obj.SiteID}`;
  }
  
  // Add required InterfaceId parameter
  if (obj.InterfaceId) {
    url += `&InterfaceId=${obj.InterfaceId}`;
  }

  if (obj.statemasterid) {
    url += `&StateID=${obj.statemasterid}`;
  }
  
  // Add optional City parameter
  if (obj.City) {
    url += `&City=${obj.City}`;
  }
  
  return getRequestHandler(url, obj);
}

export const updateBulkSiteDetails = async (obj) => {
  let url = UAPI_URL_CONFIG + "site/updateBulkSite";
  return postRequestHandler(url, obj)
};

export const updateBulkDeviceDetails = async (obj) => {
  let url = UAPI_URL_CONFIG + "deviceConfig/updateBulkDevice";
  return postRequestHandler(url, obj);
};

export const updateBulkEmergencyContact = async (obj) => {
  let url = UAPI_URL_CONFIG + "emergencyContact/updateBulkEmergencyContact";
  return postRequestHandler(url, obj);
};

export const deleteEmergencyContactMapping = async (obj) => {

  const { UserID, EmergencyContactID, ZoneID } = obj;
  console.log({UserID, EmergencyContactID, ZoneID})
  let url = UAPI_URL_CONFIG + `emergencyContact/deleteEmergencyContactMapping?UserID=${UserID}&EmergencyContactID=${EmergencyContactID}&ZoneID=${ZoneID}`;
  return deleteRequestHandler(url)
};

export const getAllEmergencyContactMappings = async (obj = {}) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  
  // Build URL with required UserID parameter
  let url = `${UAPI_URL_CONFIG}emergencyContact/getAllEmergencyContactMapping/?UserId=${UserID}`;
  
  // Add required ClientId parameter
  if (obj.CustomerID || obj.ClientID) {
    url += `&ClientId=${obj.CustomerID || obj.ClientID}`;
  }
  
  // Add required SiteId parameter
  if (obj.SiteID) {
    url += `&SiteId=${obj.SiteID}`;
  }
  
  // Add optional ZoneId parameter
  if (obj.ZoneID) {
    url += `&ZoneId=${obj.ZoneID}`;
  }

  if (obj.StateID) {
    url += `&StateID=${obj.StateID}`;
  }
  
  // Add optional City parameter
  if (obj.CityID) {
    url += `&City=${obj.CityID}`;
  }
  
  return getRequestHandler(url, obj);
}

export const updateBulkInterfaceDetails = async (obj) => {
  let url = UAPI_URL_CONFIG + "interface/updateBulkInterface";
  return postRequestHandler(url, obj);
}

export const getClientById = async (ClientId) => {
  let loggedInUser = JSON.parse(localStorage.getItem('user'))
  let UserID = loggedInUser?.Id
  let url = UAPI_URL_CONFIG + "clients/getClientById/?userId=" + UserID + "&clientId=" + ClientId;
  return getRequestHandler(url);
}

//#region Api Calling for Getting for Country
export const getMenuFunctionsUserRole = async (obj) => {
  let url = UAPI_URL_CONFIG + "masters/getMasterData";
  return postRequestHandler(url, obj)
};

export const onBoardOnVifDevice = async (obj) => {
  let url = UAPI_URL_CONFIG + "onboard/onBoardOnvifNVRDVR";
  return postRequestHandler(url, obj)
}

export const updateOnVifDevice = async (obj) => {
  let url = UAPI_URL_CONFIG + "onboard/updateOnvifNVRDVR";
  return postRequestHandler(url, obj)
}

export const getOnBoardedDeviceList = async (obj) => {
  const { UserID, InterfaceIP,InterfaceProtocolPort } = obj;
  let url = UAPI_URL_CONFIG + "deviceConfig/getInterfaceDeviceDetails?UserId=" + UserID + "&InterfaceIP=" + InterfaceIP + "&InterfaceProtocolPort=" + InterfaceProtocolPort;
  return getRequestHandler(url, obj);
}


export const preOnboardDevices = async (obj) => {
  let url = UAPI_URL_CONFIG + "onboard/onvifBulkDevicePreOnboard/";
  return postRequestHandler(url, obj)
}

export const getPreOnBoardedDeviceList = async (obj) => {
  const { UserID, CustomerID,SiteID,StageStatus } = obj;
  let url = UAPI_URL_CONFIG + "onboard/getPreOnBoardedDeviceList?userId=" + UserID + "&customerID=" + CustomerID;
    // Add required SiteId parameter
  if (SiteID) {
    url += `&siteID=${SiteID}`;
  }
  if (StageStatus) {
    url += `&stageStatus=${StageStatus}`;
  }
  return getRequestHandler(url, obj)
}

export const updatePreOnBoardedStatus = async (obj) => {
  let url = UAPI_URL_CONFIG + "onboard/updateStageDeviceOnboarding/";
  return postRequestHandler(url, obj)
}

export const addBulkOnboardStagingDevices = async (obj) => {
  let url = UAPI_URL_CONFIG + "onboard/addBulkOnboardStagingDevices/";
  return postRequestHandler(url, obj)
}

export const ValidationfBulkDevicePreOnboard = async (obj) => {
  let url = UAPI_URL_CONFIG + "onboard/ValidationfBulkDevicePreOnboard/";
  return postRequestHandler(url, obj)
}

export const clearStagingDevices = async (obj) => {
  let url = UAPI_URL_CONFIG + "onboard/clearStagingDevices/";
  return postRequestHandler(url, obj)
}


//#endregion

export const generateRtspUrl = async (obj) => {
  let url = UAPI_URL_CCTV + "generateRtspUrl/";
  return postRequestHandler(url, obj)
}

export const generateBulkRtspUrls = async (obj) => {
  let url = UAPI_URL_CCTV + "generateBulkRtspUrls/";
  return postRequestHandler(url, obj)
}
